import React, {Component} from "react";
import SelectCurrencyScreen from "../shared/SelectCurrencyScreen";
import { connect } from "react-redux";
import Currency from "@core/currencies/Currency";
import Wallet from "@core/wallet/Wallet";


class _SelectCurrencyFromScreen extends SelectCurrencyScreen {
    constructor(props){
        super(props);
    }
}

const mapStateToProps = (state) => {
    let currencies = Wallet.getInstance().getCurrencies();

    currencies = currencies.filter((x: Currency) => {
        return x.isExchangeAvailable();
    });

    return {
        currencies: currencies,
        fiatCurrency: state.wallet.fiatCurrency,
        from: state.wallet.selectedExchangeFrom,
        to: state.wallet.selectedExchangeTo,
    };
};

const mapDispatchToProps = (dispatch) => ({
    
});

const SelectCurrencyFromScreen = connect(
    mapStateToProps,
    mapDispatchToProps,
)(_SelectCurrencyFromScreen);
  
export default SelectCurrencyFromScreen;